import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Header } from "./components/Header";
import { TabNav, TabKey } from "./components/TabNav";
import { OverviewPage } from "./pages/OverviewPage";
import { FleetPage } from "./pages/FleetPage";
import { SessionsPage } from "./pages/SessionsPage";
import { UsersPage } from "./pages/UsersPage";
import { AuthGuard } from "./auth/AuthGuard";
import { setAccessTokenGetter } from "./lib/apiClient";
import { DateRange, defaultRange } from "./lib/dateRange";
import { DashboardSocketProvider } from "./live/DashboardSocketContext";
import { GoogleMapsProvider } from "./components/GoogleMapsProvider";

export default function App() {
  const { getAccessTokenSilently } = useAuth0();
  const [tab, setTab] = useState<TabKey>("ov");
  // When set, the Sessions tab opens pre-filtered to this mower (set by
  // clicking a unit on the Fleet screen). Cleared on any manual tab change.
  const [sessionMower, setSessionMower] = useState<string | undefined>(undefined);
  // Dashboard date range. Lives here (not in OverviewPage) so it survives tab
  // switches and seeds the Sessions tab's own date filters. The control itself
  // renders inside the dashboard content — see OverviewPage.
  const [range, setRange] = useState<DateRange>(defaultRange);

  // Hand the API client a way to fetch a fresh Auth0 access token so every
  // request carries Authorization: Bearer <token>.
  useEffect(() => {
    setAccessTokenGetter(() => getAccessTokenSilently());
  }, [getAccessTokenSilently]);

  const handleTabChange = (k: TabKey) => {
    setSessionMower(undefined);
    setTab(k);
  };

  const openMowerSessions = (deviceId: string) => {
    setSessionMower(deviceId);
    setTab("se");
  };

  return (
    <AuthGuard>
      {/* One live socket for the whole app — mounted inside AuthGuard so it
          only ever opens with an authenticated user's token. */}
      <DashboardSocketProvider>
      {/* One Maps script load for the whole app — the fleet map and the session
          path map would otherwise each start their own. */}
      <GoogleMapsProvider>
      <div className="wr">
        <div className="hd-wrap">
          <Header />
          <TabNav active={tab} onChange={handleTabChange} />
        </div>
        <div className="ab">
          {tab === "ov" && <OverviewPage range={range} onRangeChange={setRange} />}
          {tab === "fl" && <FleetPage onOpenSessions={openMowerSessions} />}
          {tab === "se" && (
            <SessionsPage
              startDate={range.startDate}
              endDate={range.endDate}
              initialMower={sessionMower}
            />
          )}
          {tab === "us" && <UsersPage />}
        </div>
      </div>
      </GoogleMapsProvider>
      </DashboardSocketProvider>
    </AuthGuard>
  );
}
